<script>
  import { Row } from 'element-ui'
  export default {
    name:'ElRow',
    extends:Row
  }
</script>
